export default "__VITE_ASSET__Bjs4ieRC__"